module.exports = "/_next/static/images/contact-df5aab06038749010460e8922f4b6fae.svg";